import { touch } from 'redux-form';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import {
  CREATE_PAGE_PROGRESS_MAP,
  REVIEW_APPLICATION_PAGE,
  GO_TO_PAGE_APPLICATION,
  UPDATE_PAGE_PROGRESS,
  UpdatePageProgressAction,
  CreatePageProgressMapAction,
  ReviewApplicationPageAction,
  NavigateToPageApplicationAction
} from './types';

import { ApplicationState } from '../types';
import { FORM_CONTAINER_NAME } from '../../constants';

export const navigateToPageApplication = (
  pageNumber: number
): NavigateToPageApplicationAction => {
  return {
    type: GO_TO_PAGE_APPLICATION,
    pageNumber
  };
};

export function createPageProgressMap(
  resetPageProgress = false,
  pageFieldsIds: string[] = []
): CreatePageProgressMapAction {
  return {
    type: CREATE_PAGE_PROGRESS_MAP,
    resetPageProgress,
    pageFieldsIds
  };
}

export const updatePageProgress = (
  formSyncErrors: FormSyncErrors,
  pageNumber: number
): UpdatePageProgressAction => {
  return {
    type: UPDATE_PAGE_PROGRESS,
    formSyncErrors,
    pageNumber
  };
};

export const reviewApplicationPage = (
  values: ObjectKeyStringKeyValues
): ReviewApplicationPageAction => {
  return {
    type: REVIEW_APPLICATION_PAGE,
    values
  };
};

export const goToPageApplication = (
  pageNumber = 0
): ThunkAction<void, ApplicationState, {}, Action<string>> => {
  window.scroll(0, 0);
  return dispatch => {
    dispatch(navigateToPageApplication(pageNumber));
    dispatch(createPageProgressMap());
  };
};

export const highlightMissingFields = (): ThunkAction<
  void,
  ApplicationState,
  null,
  Action<string>
> => {
  return (dispatch, getState) => {
    const {
      applicationForm: { progressMap, pageNumber }
    } = getState();

    const currentPageProgressMap = progressMap[pageNumber] || {};

    if (currentPageProgressMap.visited) {
      const fields = Object.keys(currentPageProgressMap.fields);
      dispatch(touch(FORM_CONTAINER_NAME, ...fields));
    }
  };
};
